import React from "react";
import { useNavigate, useLocation } from "react-router-dom";
import "./App.css";
import { Header } from "./components/Header";
import { Loader } from "./components/Loader";
import Routes from "./config/routes";
import { useAuth } from "./hooks/useAuthWithPermissions";

function App() {
  const navigate = useNavigate();
  const location = useLocation();
  const { isLoading, isAuthenticated: loggedIn } = useAuth();

  const navigation = {
    navigate,
    location,
  };

  return (
    <div>
      <Header navigation={navigation} loggedIn={loggedIn} />
      <main>
        <div className="main-container">
          <div className={loggedIn ? "single-column" : "login-screen"}>
            {isLoading ? (
              <div className="container">
                <div className="row justify-content-center">
                  <div className="col-md-6 col-sm-12 login">
                    <div className="text-center" style={{ padding: "60px 0" }}>
                      <Loader />
                      <div style={{ marginTop: "20px" }}>Loading...</div>
                    </div>
                  </div>
                </div>
              </div>
            ) : (
              <Routes navigation={navigation} loggedIn={loggedIn} />
            )}
          </div>
        </div>
      </main>
    </div>
  );
}

export default App;
